import { Component, EventEmitter, Injector, OnInit, Output, inject as inject_1 } from '@angular/core';
import { MatChipsModule } from '@angular/material/chips';
import { Router } from '@angular/router';
import { MatMenuModule } from '@angular/material/menu';
import { MatDividerModule } from '@angular/material/divider';

import { MatToolbarModule } from '@angular/material/toolbar';
import { jkGlb, JkGlbClass } from '../../services/jkglb';
import { JkBaseComponent } from '../jkbase/jkbase.component';

/**
 * 首頁底部狀態欄組件
 *
 * 應用程式首頁的底部狀態欄，提供使用者狀態資訊和系統操作等功能。
 * 此組件負責顯示使用者登入狀態、版本資訊，並提供登入、登出和
 * 系統更新等基本操作。
 */
@Component({
  selector: 'app-home-bottom',
  templateUrl: './home-bottom.component.html',
  //styleUrls: ['./home-bottom.component.scss'],
  styles: [``],
  standalone: true,
  imports: [MatToolbarModule, MatChipsModule, MatMenuModule, MatDividerModule],
})
export class HomeBottomComponent extends JkBaseComponent implements OnInit {
  /** 組件類型標識符 */
  override comType: string = 'home-bottom';

  /**
   * 獲取登入狀態文字
   * @returns 登入狀態文字，已登入顯示「🟢已登入」，未登入顯示「❌未登入」
   */
  get loginStatus(): string {
    let s = this.login.isLogin ? '🟢已登入' : '❌未登入';
    return s;
  }

  /** Router 服務實例 */
  public router: Router;

  /**
   * 獲取當前使用者名稱
   * @returns 使用者名稱
   */
  get username(): string {
    return this.login.name; //this.home.username;
  }

  /**
   * 獲取使用者頭像圖示
   * @returns 頭像圖示名稱
   */
  get avatarIcon(): string {
    return this.login.avatarIcon;
  }
  /**
   * 建構函數
   * @param inject 注入器，用於獲取服務和依賴
   */
  constructor() {
    const inject = inject_1(Injector);

    super();
    this.label.set('首頁');

    this.router = inject.get(Router);
    //this.home = inject.get(HomeService);
    //this.router = home.getRouter();
  }

  override ngOnInit() {
    super.ngOnInit();
  }

  /**
   * 執行登入操作
   * 導航到登入表單頁面
   */
  doLogin() {
    //page.navigateTo('/login-form');
    this.router.navigate(['/login-form']);
  }

  /**
   * 執行登出操作
   * 調用登入服務的登出方法
   */
  logout() {
    this.login.logout(this.login.hostName);
  }

  /**
   * 執行系統更新操作
   * 添加時間戳參數並重新載入頁面
   */
  doUpdate() {
    let url = window.location.host;
    let param = { timestamp: new Date().getTime() };
    //page.navigateTo('/', param);
    this.router.navigate(['/'], { queryParams: param });
    window.location.reload();
  }

  /**
   * 獲取系統版本
   * @returns 系統版本號，若jkGlb.env為null則返回錯誤訊息
   */
  get version(): string {
    if (!jkGlb.env) {
      return '告訴程式員:jkGlb.env is null';
    }
    return jkGlb.env.version;
  }
}
